import React, { FunctionComponent, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next'
// import useMediaQuery from '@mui/material/useMediaQuery';

// import { check_subdomain } from '../../lib/server_helper';
import { fetch_all, fetch_one } from "../../../lib/v31lib";
import { loginAtom } from '../../../lib/auth';
import { currentPracticeAtom } from '../../../lib/practice';

import Delete from '@mui/icons-material/Delete';

import {
  Button as Btn,
  Checkbox,
  CircularProgress,
  Divider,
  Grid,
  MenuItem,
  Paper,
} from '@mui/material';

import {
  Button,
  ColourPicker,
  Editor,
  ImagePicker,
  MultiSelect,
  Page,
  Select,
  Switcher,
  TextInput,
  Typography
} from '../../../components/v2/styled';
import { SnackSaved } from '../../../components/v2/snacks/Saved';

import { AppointmentType } from '../../../models/AppointmentType';
import { CoachSkill } from '../../../models/CoachSkill';
import { Country } from '../../../models/Country';
import { Segment } from '../../../models/Segment';
import { Questionnaire } from '../../../models/Questionnaire';
import { UserTag } from '../../../models/UserTag';

import HelpersLanguage from '../../../actions/helpers/language';

const { DateTime } = require("luxon");

type Props = {}

export const CoachAdvancedSegmentEdit: FunctionComponent<Props> = ({}) => {
  const [login, setLogin] = useAtom(loginAtom);
  const [currentPractice, setCurrentPractice] = useAtom(currentPracticeAtom);
  const theme = useTheme();
  const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);
  const params = useParams();
  const queryClient = useQueryClient();
  // const { state } = useLocation();
  
  const [objectId, setObjectId] = useState<string | undefined>(params.id);
  const [savedOpen, setSavedOpen] = useState<boolean>(false);
  const [mainObject, setMainObject] = useState<Segment>({
    name: '',
    extra_data: {
      rules: []
    }
  });
  const [currentLanguageId, setCurrentLanguageId] = useState<number>(1);
  const [currentLanguage, setCurrentLanguage] = useState<string>('nl');
  const [clapped, setClapped] = useState<number[]>([]);
  const [itemCleared, setItemCleared] = useState<boolean>(false);
  const [bgItemCleared, setBgItemCleared] = useState<boolean>(false);
  const [item, setItem] = useState<File>();
  const [bgItem, setBgItem] = useState<File>();
  const [bgItemUrl, setBgItemUrl] = useState<string>();
  const [itemUrl, setItemUrl] = useState<string>();

  const [errors, setErrors] = useState<{[z:string]: boolean}>({});

  const {
    data: object,
    isLoading: objectLoading,
    isError: objectError,
    isSuccess: objectSuccess,
    refetch: objectRefetch,
  } = useQuery({
    queryKey: ["segment", (login?.practice_id || currentPractice?.id), objectId],
    queryFn: () =>
      fetch_one<Segment>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'segment',
          id: objectId,
          fields: [
            'id', 'name', 'auto_generated', 'extra_data', 'description'
          ],
          practice_id: (login?.practice_id || currentPractice?.id)
        },
        login
      ),
    // select: (d) => {
    //   return {
    //     ...d,
    //     birth_date: DateTime.fromISO(d.birth_date).toFormat("dd/LL/y")
    //   };
    // },
    enabled: !!(login?.practice_id || currentPractice?.id) && parseInt(objectId || '', 10) > 0,
  });

  const {
    data: appointmentTypes,
    isLoading: appointmentTypesLoading,
    isError: appointmentTypesError,
    isSuccess: appointmentTypesSuccess,
    // refetch: appointmentTypesRefetch,
  } = useQuery({
    queryKey: ["appointment_types", currentPractice?.id],
    queryFn: () =>
      fetch_all<AppointmentType>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'appointment_type',
          fields: ['id', 'name', 'get_name', 'colour'],
          order: "sort_order ASC, name ASC",
          filter: {
            search: '',
            advanced: {
              practice_id: (login?.practice_id || currentPractice?.id),
              enabled: '1'
            }
          }
        },
        login
      ),
    enabled: !!currentPractice?.id
  });

  // const {
  //   data: coachSkills,
  //   isLoading: coachSkillsLoading,
  //   isError: coachSkillsError,
  //   isSuccess: coachSkillsSuccess,
  //   refetch: coachSkillsRefetch,
  // } = useQuery({
  //   queryKey: ["coach_skills"],
  //   queryFn: () =>
  //     fetch_all<CoachSkill>(
  //       `/${i18n.resolvedLanguage || 'nl'}/v3/pub/fetch_all`,
  //       {
  //         object: 'coach_skill',
  //         fields: ['id', 'name'],
  //         page: 0,
  //         per_page: 1000,
  //         order: "name ASC"
  //       },
  //       undefined
  //     ),
  // });
  const {
    data: coachSkills,
    isLoading: coachSkillsLoading,
    isError: coachSkillsError,
    isSuccess: coachSkillsSuccess,
    refetch: coachSkillsRefetch,
  } = useQuery({
    queryKey: ["coach_skills", i18n.resolvedLanguage],
    queryFn: () =>
      fetch_all<CoachSkill>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/pub/fetch_all`,
        {
          object: 'coach_skill',
          fields: ['id', 'name', 'name_en', 'name_fr', 'name_de'],
          order: 'name ASC'
        },
        undefined
      ),
    select: (res) => {
      let tempRes:CoachSkill[] = [];
      res.map(rrr => {
        let rrrClone = {...rrr};
        if (!!rrrClone.name_en && i18n.resolvedLanguage === 'en') rrrClone.name = rrrClone.name_en;
        if (!!rrrClone.name_fr && i18n.resolvedLanguage === 'fr') rrrClone.name = rrrClone.name_fr;
        if (!!rrrClone.name_de && i18n.resolvedLanguage === 'de') rrrClone.name = rrrClone.name_de;

        tempRes.push(rrrClone);
      });
      return tempRes
    },
  });

  const {
    data: countries,
    isLoading: countriesLoading,
    isError: countriesError,
    isSuccess: countriesSuccess,
    // refetch: countriesRefetch,
  } = useQuery({
    queryKey: ["countries", currentPractice?.id],
    queryFn: () =>
      fetch_all<Country>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'country',
          fields: ['id', 'name'],
          order: "name ASC",
        },
        login
      ),
    enabled: !!currentPractice?.id
  });

  const {
    data: questionnaires,
    // isLoading: objectsLoading,
    // isError: objectsError,
    isSuccess: questionnairesSuccess,
    refetch: questionnairesRefetch,
  } = useQuery({
    queryKey: ["coach", "questionnaires", (login?.practice_id || currentPractice?.id)],
    queryFn: () =>
      fetch_all<Questionnaire>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'questionnaire',
          fields: ['id', 'name', 'content_type'],
          order: 'name ASC',
          per_page: 200,
          page: 0,
          filter: {
            search: '',
            advanced: {
              only_for_knowledge: 1,
              practice_id: (login?.practice_id || currentPractice?.id)
            }
          },
          practice_id: (login?.practice_id || currentPractice?.id)
        },
        login
      ),
    enabled: !!(login?.practice_id || currentPractice?.id),
  });

  const {
    data: segments,
    isLoading: segmentsLoading,
    isError: segmentsError,
    isSuccess: segmentsSuccess,
    // refetch: segmentsRefetch,
  } = useQuery({
    queryKey: ["segments", currentPractice?.id],
    queryFn: () =>
      fetch_all<Segment>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'segment',
          fields: ['id', 'name'],
          order: "name ASC",
          filter: {
            search: '',
            advanced: {
              practice_id: (login?.practice_id || currentPractice?.id)
            }
          }
        },
        login
      ),
    enabled: !!currentPractice?.id
  });

  const {
    data: userTags,
    // isLoading: appointmentTypesLoading,
    // isError: appointmentTypesError,
    // isSuccess: appointmentTypesSuccess,
    // refetch: appointmentTypesRefetch,
  } = useQuery({
    queryKey: ["user_tags", currentPractice?.id],
    queryFn: () =>
      fetch_all<UserTag>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'user_tag',
          fields: ['id', 'name'],
          order: "name ASC",
          filter: {
            search: '',
            advanced: {
              practice_id: currentPractice?.id
            }
          }
        },
        login
      ),
    enabled: !!currentPractice?.id
  });








  const mutationSave = useMutation({
    mutationFn: (pars: {
      formData: any;
      keepOpen?: boolean
    }) => {
      return fetch_one<Segment>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/save`,
        pars.formData,
        login
      );
    },
    onMutate: (pars: {
      formData: any;
    }) => {
      return true;
    },
    onError: (data, variables, context) => {
      return true;
    },
    onSuccess: (data, variables, context) => {
      setSavedOpen(true);
      queryClient.invalidateQueries({ queryKey: ["coach", "segments", (login?.practice_id || currentPractice?.id)] });
      if (!variables.keepOpen) navigate("/segments");
      if (!!variables.keepOpen && objectId === 'new') navigate(`/segment/${data.id}`);
      if (!!variables.keepOpen && objectId !== 'new') objectRefetch();
    },
  });





  const saveObject = (keep_open: boolean) => {
    mutationSave.mutate({
      formData: {
        object: 'segment',
        handler_id: login?.id,
        practice_id:  (login?.practice_id || currentPractice?.id),
        fields: ['id'],
        id: mainObject?.id,
        ob: {
          practice_id: (login?.practice_id || currentPractice?.id),
          ...mainObject,
          extra_data: {
            ...(mainObject.extra_data || {}),
            rules: ((mainObject.extra_data || {}).rules || []).filter(r => !!r.selection)
          }
        }
      },
      keepOpen: keep_open
    });
  };

  let page_title;
  if (typeof((object || {}).id) === 'undefined') {
    page_title = t("general.titles.add", "Nieuw") + " " + t("coach.models.segments.singular", "Segment");
  } else {
    page_title = t("general.titles.edit", "Wijzig") + " " + (object || {}).name;
  }

  useEffect(() => {
    if (params.id !== 'new') objectRefetch();
  }, [params.id]);
  useEffect(() => {
    if (!!objectSuccess) setMainObject(object);
  }, [object]);
  useEffect(() => {
    let err:any = {};
    if (!mainObject.name) err.name = true;
    // if ((mainObject.extra_data?.questions || []).length < 1) err.questions = true;

    setErrors(err);
  }, [mainObject]);

  return <Page
    title={page_title}
    titleCrumbs={[
      {
        title: t("coach.menu.segments", "Segmenten"),
        path: "/segments"
      }
    ]}
  >
    <Paper sx={{padding: 2}}>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Typography variant="h5">{t("coach.submenu.segment_sections.basic")}</Typography>
          <Divider />
        </Grid>
        <Grid item xs={12} md={12}>
          <TextInput
            id="name"
            caption={t("general.segments.fields.name")}
            starred
            value={mainObject.name || ''}
            onChange={(e) => {
              setMainObject({
                ...mainObject,
                name: e
              });
            }}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <Typography sx={{fontSize: '0.8rem'}}>{t("general.segments.fields.description")}</Typography>
          <Editor
            simple
            label=""
            value={mainObject.description || ''}
            onChange={(e) => {
              setMainObject({
                ...mainObject,
                description: e
              });
            }}
          />
        </Grid>

        <Grid item xs={12} sx={{
          marginTop: 4
        }}>
          <Typography variant="h5">{t("coach.submenu.segment_sections.rules")}</Typography>
          <Typography variant="body1" sx={{
            fontStyle: 'italic',
            fontSize: '0.8rem'
          }}>{t("coach.submenu.segment_sections.rules_help")}</Typography>
          <Divider />
        </Grid>
        {((mainObject || {}).extra_data?.rules || []).length < 1 && <Grid item xs={12} sx={{textAlign: 'center'}}>
          <Typography variant="body1" sx={{
            fontStyle: 'italic',
            fontSize: '0.8rem'
          }}>{t("segments.rules.no_rules_message")}</Typography>
        </Grid>}



        {((mainObject || {}).extra_data?.rules || []).map((rule, i) => <Grid container item xs={12} spacing="8">
          <Grid item xs={6}>
            <Select
              caption="Filter"
              value={rule.selection || ''}
              id='selection'
              setValue={(v) => {
                let new_rules:{
                  selection?: string;
                  pars?: string;
                }[] = [];
                ((mainObject || {}).extra_data?.rules || []).forEach((rulee, ii) => {
                  if (i === ii) {
                    let rulee_pars = '';
                    if (v.toString() == 'gender') rulee_pars = '1';
                    if (v.toString() == 'country') rulee_pars = '1';
                    if (v.toString() == 'type') rulee_pars = 'User::User';
                    let temp_rule = {...rulee, selection: v.toString(), pars: rulee_pars};
                    new_rules.push(temp_rule);
                  } else {
                    new_rules.push(rulee);
                  }
                });

                setMainObject({
                  ...(mainObject || {}),
                  extra_data: {
                    ...((mainObject || {}).extra_data || {}),
                    rules: new_rules
                  }
                });
              }}
            >
              <MenuItem value="">{t("segments.rules.filters.none")}</MenuItem>
              <MenuItem value="---" disabled>--- {t("segments.rules.filters.separator_basic")} ---</MenuItem>
              <MenuItem value="age">{t("segments.rules.filters.age")}</MenuItem>
              <MenuItem value="age_ft">{t("segments.rules.filters.age_ft")}</MenuItem>
              <MenuItem value="gender">{t("segments.rules.filters.gender")}</MenuItem>
              <MenuItem value="gender_in">{t("segments.rules.filters.gender_in")}</MenuItem>
              <MenuItem value="zip">{t("segments.rules.filters.zip")}</MenuItem>
              <MenuItem value="country">{t("segments.rules.filters.country")}</MenuItem>
              <MenuItem value="country_in">{t("segments.rules.filters.country_in")}</MenuItem>
              <MenuItem value="type">{t("segments.rules.filters.type")}</MenuItem>
              <MenuItem value="type_in">{t("segments.rules.filters.type_in")}</MenuItem>
              <MenuItem value="usertag">{t("segments.rules.filters.user_tag")}</MenuItem>
              <MenuItem value="usertag_in">{t("segments.rules.filters.user_tag_in")}</MenuItem>
              <MenuItem value="---" disabled>--- {t("coach.models.segments.name")} ---</MenuItem>
              {(segments || []).map(seg => <MenuItem value={seg.id?.toString()}>{seg.name}</MenuItem>)}
              {/* <MenuItem value="---" disabled>---</MenuItem> */}
            </Select>
          </Grid>
          <Grid item xs={6}>
            {rule.selection !== '' && <>
              {rule.selection === 'age' && <TextInput
                caption={t("objects.segment_rule.age")}
                value={rule.pars || ''}
                id="age"
                onChange={(v) => {
                  let new_rules:{
                    selection?: string;
                    pars?: string;
                  }[] = [];
                  ((mainObject || {}).extra_data?.rules || []).forEach((rulee, ii) => {
                    if (i === ii) {
                      let temp_rule = {...rulee, pars: v};
                      new_rules.push(temp_rule);
                    } else {
                      new_rules.push(rulee);
                    }
                  });
  
                  setMainObject({
                    ...(mainObject || {}),
                    extra_data: {
                      ...((mainObject || {}).extra_data || {}),
                      rules: new_rules
                    }
                  });
                }}
              />}

              {rule.selection === 'age_ft' && <>
                <Grid container item xs={12} spacing="8">
                  <Grid item xs={6}>
                    <TextInput
                      caption={t("objects.segment_rule.age_from")}
                      value={(rule.pars || '').split("-")[0] || ''}
                      id="age_from"
                      onChange={(v) => {
                        let new_rules:{
                          selection?: string;
                          pars?: string;
                        }[] = [];
                        ((mainObject || {}).extra_data?.rules || []).forEach((rulee, ii) => {
                          if (i === ii) {
                            let old_age = (rule.pars || '').split("-");
                            let temp_rule = {
                              ...rulee,
                              pars: [v, old_age[1] || ''].join("-")
                            };
                            new_rules.push(temp_rule);
                          } else {
                            new_rules.push(rulee);
                          }
                        });
        
                        setMainObject({
                          ...(mainObject || {}),
                          extra_data: {
                            ...((mainObject || {}).extra_data || {}),
                            rules: new_rules
                          }
                        });
                      }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextInput
                      caption={t("objects.segment_rule.age_to")}
                      value={(rule.pars || '').split("-")[1] || ''}
                      id="age_to"
                      onChange={(v) => {
                        let new_rules:{
                          selection?: string;
                          pars?: string;
                        }[] = [];
                        ((mainObject || {}).extra_data?.rules || []).forEach((rulee, ii) => {
                          if (i === ii) {
                            let old_age = (rule.pars || '').split("-");
                            let temp_rule = {
                              ...rulee,
                              pars: [old_age[0] || '', v].join("-")
                            };
                            new_rules.push(temp_rule);
                          } else {
                            new_rules.push(rulee);
                          }
                        });
        
                        setMainObject({
                          ...(mainObject || {}),
                          extra_data: {
                            ...((mainObject || {}).extra_data || {}),
                            rules: new_rules
                          }
                        });
                      }}
                    />
                  </Grid>
                </Grid>
              </>}

              {rule.selection === 'gender' && <>
                <Select
                  caption={t("objects.segment_rule.gender")}
                  value={rule.pars || '1'}
                  id='gender'
                  setValue={(v) => {
                    let new_rules:{
                      selection?: string;
                      pars?: string;
                    }[] = [];
                    ((mainObject || {}).extra_data?.rules || []).forEach((rulee, ii) => {
                      if (i === ii) {
                        let temp_rule = {...rulee, pars: v?.toString()};
                        new_rules.push(temp_rule);
                      } else {
                        new_rules.push(rulee);
                      }
                    });
    
                    setMainObject({
                      ...(mainObject || {}),
                      extra_data: {
                        ...((mainObject || {}).extra_data || {}),
                        rules: new_rules
                      }
                    });
                  }}
                >
                  <MenuItem value="0">{t("general.genders.female")}</MenuItem>
                  <MenuItem value="1">{t("general.genders.male")}</MenuItem>
                  <MenuItem value="2">{t("general.genders.other")}</MenuItem>
                </Select>
              </>}

              {rule.selection === 'gender_in' && <>
                <MultiSelect
                  caption={t("objects.segment_rule.gender")}
                  value={rule.pars_in || []}
                  id='gender'
                  setValue={(v) => {
                    let new_rules:{
                      selection?: string;
                      pars?: string;
                    }[] = [];
                    ((mainObject || {}).extra_data?.rules || []).forEach((rulee, ii) => {
                      if (i === ii) {
                        let temp_rule = {...rulee, pars_in: v};
                        new_rules.push(temp_rule);
                      } else {
                        new_rules.push(rulee);
                      }
                    });
    
                    setMainObject({
                      ...(mainObject || {}),
                      extra_data: {
                        ...((mainObject || {}).extra_data || {}),
                        rules: new_rules
                      }
                    });
                  }}
                  options={[
                    {id: '0', name: t("general.genders.female")},
                    {id: '1', name: t("general.genders.male")},
                    {id: '2', name: t("general.genders.other")}
                  ]}
                  sx={{
                    marginTop: 0
                  }}
                  chips
                />
              </>}

              {rule.selection === 'type' && <>
                <Select
                  caption={t("objects.segment_rule.type")}
                  value={rule.pars || 'User::User'}
                  id='gender'
                  setValue={(v) => {
                    let new_rules:{
                      selection?: string;
                      pars?: string;
                    }[] = [];
                    ((mainObject || {}).extra_data?.rules || []).forEach((rulee, ii) => {
                      if (i === ii) {
                        let temp_rule = {...rulee, pars: v?.toString()};
                        new_rules.push(temp_rule);
                      } else {
                        new_rules.push(rulee);
                      }
                    });

                    setMainObject({
                      ...(mainObject || {}),
                      extra_data: {
                        ...((mainObject || {}).extra_data || {}),
                        rules: new_rules
                      }
                    });
                  }}
                >
                  <MenuItem value="User::User">{t("general.user_types.user")}</MenuItem>
                  <MenuItem value="User::Coach">{t("general.user_types.coach")}</MenuItem>
                </Select>
              </>}

              {rule.selection === 'type_in' && <>
                <MultiSelect
                  caption={t("objects.segment_rule.type")}
                  value={rule.pars_in || []}
                  id='type'
                  setValue={(v) => {
                    let new_rules:{
                      selection?: string;
                      pars?: string;
                    }[] = [];
                    ((mainObject || {}).extra_data?.rules || []).forEach((rulee, ii) => {
                      if (i === ii) {
                        let temp_rule = {...rulee, pars_in: v};
                        new_rules.push(temp_rule);
                      } else {
                        new_rules.push(rulee);
                      }
                    });
    
                    setMainObject({
                      ...(mainObject || {}),
                      extra_data: {
                        ...((mainObject || {}).extra_data || {}),
                        rules: new_rules
                      }
                    });
                  }}
                  options={[
                    {id: 'User::User', name: t("general.user_types.user")},
                    {id: 'User::Coach', name: t("general.user_types.coach")}
                  ]}
                  sx={{
                    marginTop: 0
                  }}
                  chips
                />
              </>}

              {rule.selection === 'country' && <>
                <Select
                  caption={t("objects.segment_rule.country")}
                  value={rule.pars || '1'}
                  id='country'
                  setValue={(v) => {
                    let new_rules:{
                      selection?: string;
                      pars?: string;
                    }[] = [];
                    ((mainObject || {}).extra_data?.rules || []).forEach((rulee, ii) => {
                      if (i === ii) {
                        let temp_rule = {...rulee, pars: v?.toString()};
                        new_rules.push(temp_rule);
                      } else {
                        new_rules.push(rulee);
                      }
                    });

                    setMainObject({
                      ...(mainObject || {}),
                      extra_data: {
                        ...((mainObject || {}).extra_data || {}),
                        rules: new_rules
                      }
                    });
                  }}
                >
                  {(countries || []).map(cnt => <MenuItem value={cnt.id?.toString()}>{cnt.name}</MenuItem>)}
                </Select>
              </>}

              {rule.selection === 'country_in' && <>
                <MultiSelect
                  caption={t("objects.segment_rule.country")}
                  value={rule.pars_in || []}
                  id='country'
                  setValue={(v) => {
                    let new_rules:{
                      selection?: string;
                      pars?: string;
                    }[] = [];
                    ((mainObject || {}).extra_data?.rules || []).forEach((rulee, ii) => {
                      if (i === ii) {
                        let temp_rule = {...rulee, pars_in: v};
                        new_rules.push(temp_rule);
                      } else {
                        new_rules.push(rulee);
                      }
                    });
    
                    setMainObject({
                      ...(mainObject || {}),
                      extra_data: {
                        ...((mainObject || {}).extra_data || {}),
                        rules: new_rules
                      }
                    });
                  }}
                  options={(countries || []).map(cnt => {return {id: (cnt.id || '0').toString(), name: cnt.name};})}
                  sx={{
                    marginTop: 0
                  }}
                  chips
                />
              </>}

              {rule.selection === 'zip' && <>
                <TextInput
                  caption={t("objects.segment_rule.zip")}
                  value={rule.pars || ''}
                  id="zip"
                  onChange={(v) => {
                    let new_rules:{
                      selection?: string;
                      pars?: string;
                    }[] = [];
                    ((mainObject || {}).extra_data?.rules || []).forEach((rulee, ii) => {
                      if (i === ii) {
                        let temp_rule = {...rulee, pars: v};
                        new_rules.push(temp_rule);
                      } else {
                        new_rules.push(rulee);
                      }
                    });
    
                    setMainObject({
                      ...(mainObject || {}),
                      extra_data: {
                        ...((mainObject || {}).extra_data || {}),
                        rules: new_rules
                      }
                    });
                  }}
                />
              </>}

              {rule.selection === 'usertag' && <>
                <Select
                  caption={t("objects.segment_rule.user_tag")}
                  value={rule.pars || '1'}
                  id='user_tag'
                  setValue={(v) => {
                    let new_rules:{
                      selection?: string;
                      pars?: string;
                    }[] = [];
                    ((mainObject || {}).extra_data?.rules || []).forEach((rulee, ii) => {
                      if (i === ii) {
                        let temp_rule = {...rulee, pars: v?.toString()};
                        new_rules.push(temp_rule);
                      } else {
                        new_rules.push(rulee);
                      }
                    });

                    setMainObject({
                      ...(mainObject || {}),
                      extra_data: {
                        ...((mainObject || {}).extra_data || {}),
                        rules: new_rules
                      }
                    });
                  }}
                >
                  {(userTags || []).map(cnt => <MenuItem value={cnt.id?.toString()}>{cnt.name}</MenuItem>)}
                </Select>
              </>}

              {rule.selection === 'usertag_in' && <>
                <MultiSelect
                  caption={t("objects.segment_rule.user_tag")}
                  value={rule.pars_in || []}
                  id='user_tag_in'
                  setValue={(v) => {
                    let new_rules:{
                      selection?: string;
                      pars?: string;
                    }[] = [];
                    ((mainObject || {}).extra_data?.rules || []).forEach((rulee, ii) => {
                      if (i === ii) {
                        let temp_rule = {...rulee, pars_in: v};
                        new_rules.push(temp_rule);
                      } else {
                        new_rules.push(rulee);
                      }
                    });

                    setMainObject({
                      ...(mainObject || {}),
                      extra_data: {
                        ...((mainObject || {}).extra_data || {}),
                        rules: new_rules
                      }
                    });
                  }}
                  options={(userTags || []).map(cnt => {return {id: (cnt.id || '0').toString(), name: (cnt.name || '')};})}
                  sx={{
                    marginTop: 0
                  }}
                  chips
                />
              </>}

              {/* {rule.selection?.indexOf('q') === 0 && <>
                <StyledSelect
                  caption={t("objects.segment_rule.answer_option")}
                  value={rule.pars || ''}
                  id='answer_option'
                  onChange={(v) => {
                    let new_rules:{
                      selection?: string;
                      pars?: string;
                    }[] = [];
                    ((mainObject || {}).extra_data?.rules || []).forEach((rulee, ii) => {
                      if (i === ii) {
                        let temp_rule = {...rulee, pars: v};
                        new_rules.push(temp_rule);
                      } else {
                        new_rules.push(rulee);
                      }
                    });
    
                    setMainObject({
                      ...(mainObject || {}),
                      extra_data: {
                        ...((mainObject || {}).extra_data || {}),
                        rules: new_rules
                      }
                    });
                  }}
                  list={[
                    {id: 'answered_1', name: 'Answered'},
                    {id: 'answered_0', name: 'Unanswered'},
                    ...((myQuestions.filter(q => q.id === parseInt((rule.selection || '').replace('question_', ''), 10))[0] || {}).simple_answer_options || []).map(ao => {
                      return {id: ao.id.toString() || '', name: ao.body?.nl || ''};
                    })
                  ]}
                />
              </>} */}
            </>}
          </Grid>
        </Grid>)}



        <Grid item xs={12}>
          <Button
            label={t("segments.rules.add_more_cta")}
            id='add_rule'
            contained
            onClick={(v) => {
              setMainObject({
                ...(mainObject || {}),
                extra_data: {
                  ...((mainObject || {}).extra_data || {}),
                  rules: [
                    ...((mainObject || {}).extra_data?.rules || []),
                    {
                      selection: '',
                      pars: ''
                    }
                  ]
                }
              });
            }}
            sx={{marginTop: 1}}
          />
        </Grid>
        







        <Grid item xs={12} sx={{
          alignContent: 'baseline',
          textAlign: 'center',
          position: {
              xs: 'relative',
              md: 'sticky'
            },
          bottom: '-24px',
          backgroundColor: 'white',
          zIndex: 1201
        }}>
          {(mainObject?.extra_data?.rules || []).filter(fff => fff.selection === 'type' || (fff.selection === 'type_in' && (fff.pars_in || []).length > 0)).length < 1 && <Typography sx={{
            color: theme.palette.warning.main,
            fontStyle: 'italic',
            fontSize: '0.9rem',
          }}>{t("general.save_warnings.segment_needs_user_type")}</Typography>}

          <Divider sx={{marginTop: 1, marginBottom: 0}} />

          {!!mutationSave.isPending && <CircularProgress />}
          {!mutationSave.isPending && <Button
            label={t("shared.buttons.save")}
            id='save'
            disabled={!mainObject?.name || (mainObject?.extra_data?.rules || []).filter(fff => fff.selection === 'type' || (fff.selection === 'type_in' && (fff.pars_in || []).length > 0)).length < 1}
            contained
            onClick={(v) => {
              saveObject(false);
            }}
            sx={{marginBottom: 1, marginTop: 1}}
          />}
          {!mutationSave.isPending && <Button
            label={t("shared.buttons.save_keep_open")}
            id='save_opened'
            disabled={!mainObject?.name || (mainObject?.extra_data?.rules || []).filter(fff => fff.selection === 'type' || (fff.selection === 'type_in' && (fff.pars_in || []).length > 0)).length < 1}
            contained
            onClick={(v) => {
              saveObject(true);
            }}
            sx={{marginLeft: 1, marginBottom: 1, marginTop: 1}}
          />}
          {!mutationSave.isPending && <Button
            label={t("shared.buttons.cancel")}
            id='cancel'
            text
            // contained
            onClick={(v) => {
              navigate("/segments");
            }}
            sx={{marginLeft: 1, marginBottom: 1, marginTop: 1}}
          />}
        </Grid>
      </Grid>
    </Paper>
    
    <SnackSaved open={savedOpen} setOpen={setSavedOpen} />
  </Page>;
}
